import styled from '@emotion/styled';
import { colorPalette, docGeniusPalette } from 'styles/partials/colors';

export const CheckboxContainer = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: '16px',
  rowGap: '10px',
  padding: '18px 16px',
});

export const Label = styled.label({
  alignItems: 'center',
  color: colorPalette.darkGray1,
  display: 'flex',
  fontSize: '12px',
  fontWeight: 400,
});

export const Input = styled.input({
  '-webkit-appearance': 'none',
  appearance: 'none',
  backgroundColor: colorPalette.backgroundWhite,
  border: `2px solid ${docGeniusPalette.primaryBlue}`,
  borderRadius: '2px',
  color: 'currentColor',
  display: 'grid',
  font: 'inherit',
  height: '18px',
  marginRight: '8px',
  marginLeft: 0,
  minWidth: '18px',
  overflow: 'hidden',
  placeContent: 'center',
  position: 'relative',
  transform: 'translateY(-0.075em)',
  width: '18px',

  '&::before': {
    color: 'white',
    content: '"\uE5CA"' /* Unicode code: checkbox */,
    fontFamily: 'Material Icons',
    fontSize: '18px',
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    visibility: 'hidden',
  },

  '&:checked': {
    backgroundColor: docGeniusPalette.primaryBlue,
  },

  '&:checked::before': {
    visibility: 'visible',
  },
});
